
import { useState } from 'react';

export default function InstructionsSection() {
  const [activeStep, setActiveStep] = useState(0);

  const instructions = [
    {
      icon: 'ri-hand-heart-line',
      title: 'Plak Takma & Çıkarma',
      content: 'Temiz ve kuru ellerle takın, kenarlardan çıkarın, tırnak kullanmayın.',
      tips: ['Ellerinizi sabunla yıkayın', 'Plaği yavaşça takın', 'Zorlamayın']
    },
    {
      icon: 'ri-time-line',
      title: 'Kullanım Süresi',
      content: 'Günde 20-22 saat takılı kalmalı, yalnızca yemek ve fırçalama sırasında çıkarın.',
      tips: ['Minimum 20 saat', 'Yemek öncesi çıkarın', 'Fırçalama sonrası takın']
    },
    {
      icon: 'ri-drop-line',
      title: 'Temizlik',
      content: 'Ilık su ve yumuşak fırça, kimyasal kullanmayın, suda bekletmeyin.',
      tips: ['Ilık su kullanın', 'Yumuşak fırça', 'Kimyasal yasak']
    },
    {
      icon: 'ri-restaurant-line',
      title: 'Yemek & İçecek',
      content: 'Yalnızca suyla takılı kalabilir, sıcak-asidik içeceklerde çıkarın.',
      tips: ['Sadece su içebilirsiniz', 'Sıcak içecek yasak', 'Yemek öncesi çıkarın']
    },
    {
      icon: 'ri-archive-line',
      title: 'Saklama',
      content: 'Özel kutuda muhafaza edin, peçete veya çantada açık bırakmayın.',
      tips: ['Özel kutu kullanın', 'Temiz yerde saklayın', 'Açık bırakmayın']
    },
    {
      icon: 'ri-refresh-line',
      title: 'Değişim',
      content: 'Doktorun belirlediği periyotlarda, hasarda iletişime geçin.',
      tips: ['Doktor takvimini takip edin', 'Hasar durumunda hemen arayın', 'Düzenli kontrol']
    },
    {
      icon: 'ri-tooth-line',
      title: 'Ağız Bakımı',
      content: 'Her takmadan önce dişleri fırçalayın.',
      tips: ['Dişleri fırçalayın', 'Ağız gargarası yapın', 'Temiz ağız şart']
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Önemli Öneriler',
      content: 'İlk günlerde hafif baskı normaldir, şiddetliyse doktora danışın.',
      tips: ['Hafif ağrı normal', 'Şiddetli ağrıda doktora başvurun', 'Sabırlı olun']
    }
  ];

  return (
    <section id="instructions" className="section-padding py-20 bg-white">
      <div className="container-max">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-black">
            <span className="text-gradient">Şeffaf Plak</span> Kullanım Talimatları
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Tedavinizin başarısı için bu talimatları dikkatli bir şekilde uygulayın
          </p>
        </div>

        {/* Mobile View - Accordion Style */}
        <div className="lg:hidden space-y-4">
          {instructions.map((instruction, index) => (
            <div key={index} className="bg-white border border-gray-200 rounded-xl shadow-lg">
              <button
                onClick={() => setActiveStep(activeStep === index ? -1 : index)}
                className="w-full flex items-center justify-between p-4 text-left"
              >
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-[#D4AF37] to-[#B8941F] rounded-full flex items-center justify-center">
                    <i className={`${instruction.icon} text-xl text-white`}></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-black">{instruction.title}</h3>
                  </div>
                </div>
                <i className={`ri-arrow-down-s-line text-2xl text-[#D4AF37] transition-transform duration-300 ${
                  activeStep === index ? 'rotate-180' : ''
                }`}></i>
              </button>
              
              {activeStep === index && (
                <div className="px-4 pb-4 border-t border-gray-200 mt-4 pt-4">
                  <p className="text-gray-700 mb-4">{instruction.content}</p>
                  <div className="space-y-2">
                    <h4 className="text-sm font-semibold text-[#D4AF37] mb-2">İpuçları:</h4>
                    {instruction.tips.map((tip, tipIndex) => (
                      <div key={tipIndex} className="flex items-center gap-2">
                        <i className="ri-check-line text-[#D4AF37] text-sm"></i>
                        <span className="text-sm text-gray-600">{tip}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Desktop View - Grid Style */}
        <div className="hidden lg:grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {instructions.map((instruction, index) => (
            <div key={index} className="bg-white border border-gray-200 rounded-xl shadow-lg p-6 group hover:scale-105 hover:shadow-xl transition-all duration-300">
              <div className="text-center">
                <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-br from-[#D4AF37] to-[#B8941F] rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                  <i className={`${instruction.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-xl font-semibold text-[#D4AF37] mb-3">{instruction.title}</h3>
                <p className="text-gray-700 leading-relaxed mb-4">{instruction.content}</p>
                
                <div className="space-y-2">
                  <h4 className="text-sm font-semibold text-[#D4AF37] mb-2">İpuçları:</h4>
                  {instruction.tips.map((tip, tipIndex) => (
                    <div key={tipIndex} className="flex items-center gap-2 text-left">
                      <i className="ri-check-line text-[#D4AF37] text-sm"></i>
                      <span className="text-sm text-gray-600">{tip}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <div className="bg-gray-50 border border-gray-200 rounded-xl p-6 max-w-4xl mx-auto">
            <div className="flex items-center gap-4 mb-4">
              <i className="ri-information-line text-2xl text-[#D4AF37]"></i>
              <h3 className="text-xl font-semibold text-black">Önemli Hatırlatma</h3>
            </div>
            <p className="text-gray-700 leading-relaxed">
              Bu talimatlar genel rehber niteliğindedir. Tedavi planınız kişiye özeldir; 
              kesin bilgi ve özel durumlar için mutlaka diş hekiminize danışın.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
